import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

export const StyledNoImage = styled(SWReactIcons)` {
  svg {
    width: 100%;
    height: 100%;
  }
`;
